/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2024-10-21 11:09:13
 * @LastEditors: linxi
 * @LastEditTime: 2025-04-03 18:01:41
 */
import { Col, Popover, Space, TableColumnType } from 'antd'
import moment from 'moment'
import React, { ReactElement } from 'react'
import {
  DateTimeFormatSimples,
} from '../../../../models/datetime'
import styles from './TraceCodeFlow.module.css'

export const Column = (startIndex: number): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      key: 'no',
      align: 'center',
      width: '4rem',
      render: (_1, _2, i) => `${startIndex + i + 1}`,
      fixed: 'left',
    },
    {
      title: '产品信息',
      align: 'left',
      width:'300px',
      ellipsis:true,
      render: function Element(_, t) {
        return (
          <Space style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Col>
              <Popover
                content={
                  <>
                    <div style={{ height: '55px' }}>
                      <p
                        className={styles.nameText}
                      >
                        {t.name}
                      </p>
                      <p
                        className={styles.productText}
                      >
                        {t.productInfo}
                      </p>
                    </div>
                  </>
                }
                placement='bottom'
              >
                <div
                  style={{ height: '55px', width: '300px', overflow: 'hidden' }}
                >
                  <p
                    className={styles.nameText}
                  >
                    {t.name}
                  </p>
                  <p
                    className={styles.productText}
                  >
                    {t.productInfo}
                  </p>
                </div>
              </Popover>
            </Col>
          </Space>
        )
      },
    },
    {
      title: '追溯码',
      align: 'center',
      dataIndex: '',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t?.traceCode ? t?.traceCode : '-'
      },
    },
    {
      title: '患者姓名',
      align: 'center',
      dataIndex: '',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t?.patientName ? t?.patientName : '-'
      },
    },
    {
      title: '结算险种',
      dataIndex: 'insuranceCode',
      width: '10em',
      align: 'center',
      render: (_, t) => {
        return  t?.insuranceCode &&
          t?.insuranceCode === 'ZIFEI'
          ? '自费'
          : '智慧医保'
      },
    },
    {
      title: '国家医保代码',
      align: 'center',
      dataIndex: '',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t?.hilistCode ? t?.hilistCode : '-'
      },
    },
    {
      title: '医保上传状态',
      align: 'center',
      dataIndex: 'medicalUploadStatus',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t?.businessType == '1'
          ? t?.medicalUploadStatus == 0
            ? '未上传'
            : t?.medicalUploadStatus == 1
            ? '发药已上传'
            : t?.medicalUploadStatus == 2
            ? '退药已上传'
            : '-'
          : t?.businessType == '2'
          ? t?.medicalUploadStatus == 0
            ? '未上传'
            : t?.medicalUploadStatus == 1
            ? '入库已上传'
            : '-'
          : '-'
      },
    },
    {
      title: '业务名称',
      align: 'center',
      dataIndex: 'businessType',
      width: '7rem',
      ellipsis: true,
      render: (_, t) => {
        return t?.businessType ==1 ? '发药/退药上传' : t?.businessType == 2  ? '入库上传' : '-'
      },
    },
    {
      title: '操作人员',
      align: 'center',
      dataIndex: 'operateName',
      width: '6rem',
      ellipsis: true,
      render: (_, t) => {
        return t?.operateName ? t?.operateName : '-'
      },
    },
    {
      title: '业务时间',
      align: 'center',
      dataIndex: 'deadline',
      width: '9rem',
      ellipsis: true,
      render: (_, t) => {
        return t.businessTime
          ? moment(t.businessTime).format(DateTimeFormatSimples)
          : '-'
      },
    },
    {
      title: '扫码时间',
      align: 'center',
      dataIndex: '',
      width: '9rem',
      ellipsis: true,
      render: (_, t) => {
        return t?.scanTime
          ? moment(t.scanTime).format(DateTimeFormatSimples)
          : '-'
      },
    },
  ]
}
